import { publicUrl } from '../../theme/functions/publicUrl';
import styles from './Logo.module.css';

interface LogoProps {
  size?: string;
  isLoading?: boolean;
}

export function Logo(props: LogoProps) {
  return (
    <img
      className={styles.root}
      style={{
        '--prop-size': props.size,
      }}
      src={publicUrl('img/logo.png')}
      alt={'Homey logo'}
      data-is-loading={props.isLoading ?? false}
    />
  );
}
